import { useStaticQuery, graphql } from 'gatsby'

export const useHeaderData = () => {
    return useStaticQuery(
        graphql`
            query HeaderData {
                allContentfulHeader(filter: { property: { name: { regex: "/pazola/i" } } }) {
                    edges {
                        node {
                            id
                            links {
                                title
                                slug
                                node_locale
                            }
                            brochure {
                                file {
                                    url
                                }
                            }
                            node_locale
                        }
                    }
                }
            }
        `
    )
}
